
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter/[...slug]",
      function () {
        return require("private-next-pages/newsletter/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletter/[...slug]"])
      });
    }
  